import React, { useState, useEffect } from "react";

import { Row, Col, Card, Button,  } from "react-bootstrap";

import axios from "axios";
import config from "../../../config/config";
import { Link } from "react-router-dom";

const url = `${config.baseURL}/founders/`;
const image_url = "https://res.cloudinary.com/daiur8cgx/";

function FoundersListView({currentFounderId}) {
  const [foundersListData, setFoundersListData] = useState([]);
  console.log(currentFounderId)
  useEffect(() => {
    console.log(currentFounderId)
    axios.get(url).then((response) => {
      console.log(response);
      setFoundersListData(response.data);
    });
  }, [currentFounderId]);
  return (
    <Row xs={1} md={3} className="g-4 mb-3 px-4">
      {foundersListData
        .filter((founder) => Number(founder.id) !== Number(currentFounderId))
        .map((founder) => {
          return (
            <Col key={founder.id}>
              <Card className="rounded-0 ">
                <Card.Img
                  variant="top"
                  src={`${founder.image.replace("media", "static")}`}
                  alt={founder.name}
                  style={{ objectFit: true }}
                  className="rounded-0"
                />
                <Card.Body>
                  <Link
                    className="btn button-gradient"
                    role={Button}
                    to={`/founders/${founder.id}/`}
                  >
                    Read More
                  </Link>
                </Card.Body>
              </Card>
            </Col>
          );
        })}
    </Row>
  );
}

export default FoundersListView;
